import { render, staticRenderFns } from "./loginSocialSignin.vue?vue&type=template&id=db1236c6&scoped=true&"
import script from "./loginSocialSignin.vue?vue&type=script&lang=js&"
export * from "./loginSocialSignin.vue?vue&type=script&lang=js&"
import style0 from "./loginSocialSignin.vue?vue&type=style&index=0&id=db1236c6&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1236c6",
  null
  
)

export default component.exports